import { NgModule ,ApplicationRef,Injector, Inject, provideZoneChangeDetection } from "@angular/core";
import { downgradeComponent, downgradeInjectable, downgradeModule, UpgradeModule } from "@angular/upgrade/static";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule } from "@angular/forms";
import { HttpClientModule  } from "@angular/common/http";

import { DragDropModule } from '@angular/cdk/drag-drop';

import { UIRouterUpgradeModule } from "@uirouter/angular-hybrid";
import { RouterModule } from '@angular/router';


import { AppComponent } from "./app.component";
//import { ng1App } from "../app/ng1.module";
import "@angular/compiler";
//import angular from 'angular';
//import 'zone.js/dist/zone';
import 'zone.js';


// angularjs entities brought in as angular 2+ entities
export function getMSF(i:any) { return i.get('MySynchFactory')}
export function getViewAuth(i:any) { return i.get('ViewAuthorizationFactory')}
export function getCookieFactory(i:any) { return i.get('CookieFactory')}
export function getApiBase(i:any) { return i.get('ApiBase')}
export function getApiFactory(i:any) { return i.get('ApiFactory')}
export function getF360Constant(i:any) { return i.get('F360Constant')}
export function getIndexedDBFactory(i:any) { return i.get('IndexedDBFactory')}
export function  getMySynchEnumerationConfigFactory(i:any) { 
                                                      var mySynchEnumerationConfig = i.get('mySynchEnumerationConfig');
                                                      return mySynchEnumerationConfig.refreshMySynchEnumerationsData();
                                                    } 
//export function getTransitionsService(i:any) { return i.get('Transitions')}

// angularjs wrapped entities
import { Ng1AppComponentWrapper } from "./ng1app-componentwrapper.directive";
import { Ng1FarmSelectComponentWrapper } from "./ng1-wrappers/ng1-farm-select-componentwrapper.directive";
import { UibBtnRadioWrapperComponent } from "./ng1-wrappers/bootstrap-wrappers/uib-btn-radio-wrapper/uib-btn-radio-wrapper.component";
// angular entities
import {SiteMainHeader} from "./headers/site-main-header/site-main-header.component";
import {AccountHeader} from "./headers/account-header/account-header.component";
import { MySynchDataStore } from "./data-stores/mysynch.datastore";
import { BroadCastService } from "./services/broadcast.service";
import { ModalService} from "./services/modal.service";
import { ModalDataService } from "./services/modal-data.service";
import { MySynchEnumerationService } from "./services/mysynch.enumeration.service";
import { SiteNavigation } from "./navigation/site-navigation/site-navigation.component";
import { NavigationSection } from "./navigation/navigation-section/navigation-section.component";
import { NavigationSubmenu } from "./navigation/navigation-submenu/navigation-submenu.component";
import { MySynchMultiSelect } from "./form-controls/mysynch-multiselect/mysynch-multiselect.component";
import { MySynchSelect } from "./form-controls/mysynch-select/mysynch-select.component";
import { MySynchSimpleSelect } from "./form-controls/mysynch-simple-select/mysynch-simple-select.component";
import { ShinyAppComponent } from "./content-components/shiny-app/shiny-app.component";
import { ButtonRadioGroup } from "./form-controls/button-radio-group/button-radio-group.component";
import { IncompleteSetupMixinComponent } from "./content-components/incomplete-setup-mixin/incomplete-setup-mixin.component";
import { MySynchViewService } from "./services/mysynch.view.service";
import { MySynchConstantService } from "./services/mysynch.constant.service";
import { MySynchFormatterService } from "./services/mysynch-formatter.service";
import { PageTrackerService } from "./services/page-tracker.service";
import { PerformanceMetricsService } from "./services/performance-metrics.service";
import {TabSet} from "./content-components/tab-set/tab-set.component";
import { FertilityCalendar } from "./content-components/fertility-calendar/fertility-calendar.component";
import { ExportService } from "./services/export.service";
import { LongPressDirective } from "./directives/long-press.directive";
import { ClientLoggerService } from "./services/client-logger.service";
import { PerformanceContextService } from "./services/performance-context.service";

// pipes
import { SafeSpecialCharFilterPipe } from "./pipes/safeSpecialCharFilter.pipe";
import { DemoUserFilter } from "./pipes/demo-user-filter.pipe";

// modals
import { MysynchModalContainerComponent } from "./modals/mysynch-modal-container.component";
import { MysynchModalComponent } from "./modals/mysynch-modal/mysynch-modal.component";
import { OutofdateDataModalComponent } from "./modals/outofdate-data-modal/outofdate-data-modal.component";
import { NoMetaDataDateModalComponent } from "./modals/no-metadata-date-modal/no-metadata-date-modal.component";



// npm modules
import { DeviceDetectorService } from "ngx-device-detector";
import { NgSelectModule } from '@ng-select/ng-select';
import { ClipboardModule } from 'ngx-clipboard';




// angular pages
import { UserProfile } from "./pages/user-profile/user-profile.component";
import { ConceptionDashboard } from "./pages/conception-dashboard/conception-dashboard.component";
import { Journal } from "./pages/journal/journal.component";
import { JournalMaint } from "./pages/journal-maint/journal-maint.component";
import { FarmDemographics } from "./pages/farm-demographics/farm-demographics.component";
import { KpiDashboard } from "./pages/kpi-dashboard/kpi-dashboard.component";
import { NewUser } from "./pages/new-user/new-user.component";
import { SpecialReports } from "./pages/special-reports/special-reports.component";
import { Help } from "./pages/help/help.component";
import { ForgotPassword } from "./pages/forgot-password/forgot-password.component";
import { PasswordReset } from "./pages/password-reset/password-reset.component";
import { Login } from "./pages/login/login.component";
import { UserManagement } from "./pages/user-management/user-management.component";
import { Benchmarking } from "./pages/benchmarking/benchmarking.component";
import { TrendsAndTargets } from "./pages/trends-and-targets/trends-and-targets.component";
import { HerdData } from "./pages/herd-data/herd-data.component";
import { AdminUserManagement } from "./pages/admin-user-management/admin-user-management.component";
import { AdminUserManagementMaint } from "./pages/admin-user-management-maint/admin-user-management-maint.component";
import { AdminFarmManagement } from "./pages/admin-farm-management/admin-farm-management.component";
import { AdminFarmManagementMaint } from "./pages/admin-farm-management-maint/admin-farm-management-maint.component";
import {TMDashboard} from "./pages/tm-dashboard/tm-dashboard.component";
import { TMTestFarmsView } from "./pages/tm-dashboard/views/tm-test-farms-view/tm-test-farms-view.component";
import {TMActiveFarmsView} from "./pages/tm-dashboard/views/tm-active-farms-view/tm-active-farms-view.component";
import {TMInactiveFarmsView} from "./pages/tm-dashboard/views/tm-inactive-farms-view/tm-inactive-farms-view.component";

import { FertilityCalendars } from "./pages/fertility-calendars/fertility-calendars.component";


//export let AppInjector: Injector;

declare var $:JQueryStatic;

@NgModule({
   imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    UpgradeModule,
    UIRouterUpgradeModule,//.forRoot({ states: [] }),   
    NgSelectModule,
    RouterModule.forRoot([]),
    DragDropModule,
    ClipboardModule,
   ],
   declarations: [
    AppComponent,
    Ng1AppComponentWrapper,
    Ng1FarmSelectComponentWrapper,
    UibBtnRadioWrapperComponent,
    SiteMainHeader,
    AccountHeader,
    SiteNavigation,
    NavigationSection,
    NavigationSubmenu,
    MySynchMultiSelect,
    MySynchSelect,
    MySynchSimpleSelect,
    ButtonRadioGroup,
    SafeSpecialCharFilterPipe,
    MysynchModalContainerComponent,
    MysynchModalComponent,
    OutofdateDataModalComponent,
    NoMetaDataDateModalComponent,
    DemoUserFilter,
    IncompleteSetupMixinComponent,
    ShinyAppComponent,
    TabSet,
    FertilityCalendar,
    LongPressDirective,
    //pages
    UserProfile,
    ConceptionDashboard,
    Journal,
    JournalMaint,
    FarmDemographics,
    KpiDashboard,
    NewUser,
    SpecialReports,
    Help,
    ForgotPassword,
    PasswordReset,
    Login,
    UserManagement,
    Benchmarking,
    TrendsAndTargets,
    HerdData,
    AdminUserManagement,
    AdminUserManagementMaint,
    AdminFarmManagement,
    AdminFarmManagementMaint,
    TMDashboard,
    TMTestFarmsView,
    TMActiveFarmsView,
    TMInactiveFarmsView,
    FertilityCalendars,
   ],
   providers: [
    provideZoneChangeDetection(),
    {
        provide:'MySynchFactory',
        useFactory: getMSF,
        deps: ['$injector']
    },
    {
      provide:'ViewAuthorizationFactory',
      useFactory: getViewAuth,
      deps: ['$injector']
    },
    {
      provide:'CookieFactory',
      useFactory: getCookieFactory,
      deps: ['$injector']
    },
    {
      provide:'ApiBase',
      useFactory: getApiBase,
      deps: ['$injector']
    },
    {
      provide:'ApiFactory',
      useFactory: getApiFactory,
      deps: ['$injector']
    },
    {
      provide:'F360Constant',
      useFactory: getF360Constant,
      deps: ['$injector']
    },
    {
      provide:'IndexedDBFactory',
      useFactory: getIndexedDBFactory,
      deps: ['$injector']
    },
    {
      provide:'mySynchEnumerationConfig',
      useFactory: getMySynchEnumerationConfigFactory,
      deps: ['$injector']
    },
    {
      provide: '$scope',
      useFactory: i => i.get('$rootScope'),
      deps: ['$injector']
    },
    {
      provide: '$transitions',
      useFactory: i => i.get('$transitions'),
      deps: ['$injector']
    },
    MySynchDataStore,
    BroadCastService,
    DeviceDetectorService,
    ModalService,
    ModalDataService,
    MySynchEnumerationService,
    MySynchViewService,
    MySynchConstantService,
    MySynchFormatterService,
    PageTrackerService,
    PerformanceMetricsService,
    DemoUserFilter,
    ExportService,
    ClientLoggerService,
    PerformanceContextService,
   ]
})
export class AppModule {
  
  constructor( @Inject(UpgradeModule) public upgradeModule: UpgradeModule) {
    
  }
  ngDoBootstrap ( appRef: ApplicationRef ) {

   /************************************************/ 
    // All downgrading and upgrading needs to happen here before bootstrapping

    angular.module("mySynch")
    .factory("mySynchEnumerationService",   downgradeInjectable(MySynchEnumerationService))
    .factory("mySynchDataStore",            downgradeInjectable(MySynchDataStore))
    .factory("broadCastService",            downgradeInjectable(BroadCastService))
    .factory("mySynchViewService",          downgradeInjectable(MySynchViewService))
    .factory("mySynchConstantService",      downgradeInjectable(MySynchConstantService))
    .factory("modalService",                downgradeInjectable(ModalService))
    .factory("modalDataService",            downgradeInjectable(ModalDataService))
    .factory("mySynchFormatterService",     downgradeInjectable(MySynchFormatterService))
    .factory("pageTrackerService",          downgradeInjectable(PageTrackerService))
    .factory("performanceMetricsService",  downgradeInjectable(PerformanceMetricsService))
    .factory("clientLoggerService",         downgradeInjectable(ClientLoggerService))
    .factory("performanceContextService",   downgradeInjectable(PerformanceContextService))
      

    .directive("mysynchModalContainer",     downgradeComponent({component: MysynchModalContainerComponent}))
    .directive("siteMainHeader",            downgradeComponent({component: SiteMainHeader}))
    .directive("accountHeader",             downgradeComponent({component: AccountHeader}))
    .directive("siteNavigation",            downgradeComponent({component: SiteNavigation}))
    .directive("mysynchMultiSelect",        downgradeComponent({component: MySynchMultiSelect}))
    .directive("mysynchSelect",             downgradeComponent({component: MySynchSelect}))
    .directive("mysynchSimpleSelect",       downgradeComponent({component: MySynchSimpleSelect}))
    .directive("userProfile",               downgradeComponent({component: UserProfile}))
    .directive("conceptionDashboard",       downgradeComponent({component: ConceptionDashboard}))
    .directive("journal",                   downgradeComponent({component: Journal}))
    .directive("journalMaint",              downgradeComponent({component: JournalMaint}))
    .directive("farmDemographics",          downgradeComponent({component: FarmDemographics}))
    .directive("kpiDashboard",              downgradeComponent({component: KpiDashboard}))
    .directive("newUser",                   downgradeComponent({component: NewUser}))
    .directive("specialReports",            downgradeComponent({component: SpecialReports}))
    .directive("help",                      downgradeComponent({component: Help}))
    .directive("forgotPassword",            downgradeComponent({component: ForgotPassword}))
    .directive("passwordReset",             downgradeComponent({component: PasswordReset}))
    .directive("login",                     downgradeComponent({component: Login}))
    .directive("userManagement",             downgradeComponent({component: UserManagement}))
    .directive("benchmarking",               downgradeComponent({component: Benchmarking}))
    .directive("trendsAndTargets",          downgradeComponent({component: TrendsAndTargets}))
    .directive("herdData",                  downgradeComponent({component: HerdData}))
    .directive("adminUserManagement",         downgradeComponent({component: AdminUserManagement}))
    .directive("adminUserManagementMaint",      downgradeComponent({component: AdminUserManagementMaint}))
    .directive("adminFarmManagement",         downgradeComponent({component: AdminFarmManagement}))
    .directive("adminFarmManagementMaint",      downgradeComponent({component: AdminFarmManagementMaint}))
    .directive("tmDashboard",      downgradeComponent({component: TMDashboard}))
    .directive("tmTestFarmsView",      downgradeComponent({component: TMTestFarmsView}))
    .directive("tmActiveFarmsView",      downgradeComponent({component: TMActiveFarmsView}))
    .directive("tmInactiveFarmsView",      downgradeComponent({component: TMInactiveFarmsView}))
    .directive("fertilityCalendars",      downgradeComponent({component: FertilityCalendars}))

   /************************************************/ 
    var test = this.upgradeModule.bootstrap(document.body, ['mySynch'],{ strictDi: true } )
        appRef.bootstrap ( AppComponent )
  }
}